<template>
  <div class="av-form">
    <!-- Preview -->
    <div class="av-preview">
      <div
        class="avatar avatar--xl avatar--ring av-thumb"
        :style="
          newPhoto || oldPhoto
            ? `background-image:url(${newPhoto ||
                oldPhoto});background-size:cover;background-position:center;`
            : ''
        "
      >
        <span v-if="!newPhoto && !oldPhoto">{{ initials }}</span>
      </div>
      <p class="av-hint">JPG ou PNG · máx 5 MB · recomendado 800×800 px</p>
    </div>

    <!-- Input oculto -->
    <input
      ref="fileInput"
      type="file"
      accept=".png,.jpg,.jpeg"
      style="display:none"
      @change="onFileSelect"
    />

    <!-- Botões de escolha -->
    <div class="av-actions">
      <button class="btn btn--outline" @click.prevent="onFileInputOpen">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
          style="margin-right:var(--space-2)"
        >
          <path
            d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        Fazer upload
      </button>
      <button class="btn btn--ghost" @click.prevent="openModalPhoto()">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
          style="margin-right:var(--space-2)"
        >
          <path
            d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <circle
            cx="12"
            cy="13"
            r="4"
            stroke="currentColor"
            stroke-width="2"
          />
        </svg>
        Usar webcam
      </button>
    </div>

    <!-- Erro -->
    <p v-if="errorMessages.length" class="av-error">
      {{ showEnrollError }}
      <BIconX @click="onCloseErrorMessage" style="cursor:pointer" />
    </p>

    <!-- Sucesso -->
    <p v-if="hasUpdated" class="av-success">
      Foto atualizada com sucesso!
      <BIconX @click="onCloseSuccessMessage" style="cursor:pointer" />
    </p>

    <!-- Salvar -->
    <button
      class="btn btn--primary"
      style="width:100%;margin-top:var(--space-2)"
      :disabled="!hasANewPhoto"
      @click.prevent="updatePhoto()"
    >
      Salvar foto
    </button>

    <!-- Modal: webcam -->
    <BModal
      id="takePhoto"
      ref="takePhoto"
      hide-footer
      centered
      title="Tirar foto"
    >
      <div class="av-cam">
        <video ref="camera" id="preview" width="100%" height="auto"
autoPlay
/>
        <button
          class="btn btn--primary"
          style="width:100%;margin-top:var(--space-4)"
          @click.prevent="takePhoto()"
        >
          Tirar foto
        </button>
      </div>
    </BModal>
  </div>
</template>

<script>
import Compressor from "compressorjs";

export default {
  name: "AvatarForm",

  data() {
    return {
      oldPhoto: "",
      newPhoto: "",
      hasUpdated: false,
      errorMessages: [],
      camera: {
        blob: null,
        devices: [],
        constraints: {},
        selected: null
      }
    };
  },

  mounted() {
    this.oldPhoto = this.$store.state.user.currentUser.photo;
    this.$root.$on("bv::modal::hide", () => {
      this.stopCam();
    });
  },

  methods: {
    onFileSelect(event) {
      this.createBase64File(event.target.files[0]);
    },
    onFileInputOpen() {
      this.$refs.fileInput.click();
    },
    createBase64File(file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.oldPhoto = this.$store.state.user.currentUser.photo;
        this.newPhoto = reader.result;
      };
    },
    openModalPhoto() {
      this.$bvModal.show("takePhoto");
      setTimeout(() => {
        this.openCam();
      }, 5);
    },
    takePhoto() {
      const that = this;
      navigator.mediaDevices.getUserMedia({ video: true }).then(mediaStream => {
        const track = mediaStream.getVideoTracks()[0];
        const imageCapture = new ImageCapture(track);
        imageCapture.takePhoto().then(blob => {
          new Compressor(blob, {
            quality: 0.2,
            height: 540,
            width: 960,
            success(result) {
              const reader = new FileReader();
              reader.readAsDataURL(result);
              reader.onloadend = function() {
                that.stopCam();
                that.newPhoto = reader.result;
                that.$bvModal.hide("takePhoto");
              };
            }
          });
        });
      });
    },
    openCam() {
      const constraints = { video: { width: 555, height: 367 } };
      navigator.mediaDevices.getUserMedia(constraints).then(mediaStream => {
        const video = document.querySelector("video");
        video.srcObject = mediaStream;
        video.onloadedmetadata = () => video.play();
      });
    },
    stopCam() {
      if (this.$refs.camera && this.$refs.camera.srcObject) {
        this.$refs.camera.srcObject.getTracks().forEach(t => t.stop());
        this.camera = {
          blob: null,
          devices: [],
          constraints: {},
          selected: null
        };
      }
    },
    onCloseSuccessMessage() {
      this.hasUpdated = false;
    },
    onCloseErrorMessage() {
      this.errorMessages = [];
    },
    async updatePhoto() {
      if (!this.hasANewPhoto) return;
      const payload = {
        id: this.$store.state.user.currentUser.id,
        photo: { data: this.newPhoto }
      };
      this.$store.dispatch("user/updateUser", payload).then(() => {
        this.hasUpdated = true;
      });
    }
  },

  computed: {
    hasANewPhoto() {
      return this.newPhoto !== "" && this.newPhoto !== this.oldPhoto;
    },
    initials() {
      const name = this.$store.state.user.currentUser?.name || "";
      return (
        name
          .split(" ")
          .slice(0, 2)
          .map(n => n[0])
          .join("")
          .toUpperCase() || "?"
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.av-form {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.av-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-5) 0 var(--space-2);
}

.av-thumb {
  width: 96px;
  height: 96px;
  font-size: var(--font-size-2xl);
}

.av-hint {
  font-size: var(--font-size-xs);
  color: var(--color-gray-500);
  text-align: center;
  margin: 0;
}

.av-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-3);
}

.av-error {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
  padding: var(--space-3) var(--space-4);
  background: #fef2f2;
  color: var(--color-danger);
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  margin: 0;
}

.av-success {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
  padding: var(--space-3) var(--space-4);
  background: #ecfdf5;
  color: #065f46;
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  font-weight: var(--fw-semibold);
  margin: 0;
}

.av-cam {
  display: flex;
  flex-direction: column;
}

video {
  border-radius: var(--radius-lg);
  background: var(--color-gray-100);
}
</style>
